'use strict';
var sharedCustomDateTimePickerTpl = require('./customDateTimePicker.html');
var util = require('../../util/property-util');
require('../../../js/other/timepickerpop'); // TODO find an NPM alternative

module.exports = /*@ngInject*/ ["$document", "timepickerState", "TimeZoneFactory", function customDateTimePicker($document, timepickerState, TimeZoneFactory) {
    return {
        restrict: 'E',
        transclude: false,
        scope: {
            inputTime: "=?",
            minTime: '=?',
            maxTime: '=?',
            useTz: "=?",
            disabled: "=?",
            change: "=?"
        },

        template: sharedCustomDateTimePickerTpl,

        controller: ['$scope', '$element', function ($scope, $element) {
            $scope.isOpen = false;
            $scope.datePickerOpen = false;

            $scope.disabledInt = angular.isUndefined($scope.disabled) ? false : $scope.disabled;
            $scope.useTz = util.isDefined($scope.useTz) ? $scope.useTz : false;

            $scope.toggle = function () {
                if ($scope.isOpen) {
                    $scope.close();
                } else {
                    $scope.open();
                }
            };
        }],

        link: function (scope, element, attrs) {
            if (!angular.isDate(scope.inputTime)) {
                scope.inputTime = new Date(scope.inputTime);
            }

            scope.internalTime = scope.inputTime;
            scope.internalDate = scope.inputTime;

            scope.$watch('internalTime', function (newTime) {
                var time =  new Date(newTime);
                if (util.isDefined(newTime)) {
                    var hour, minute;

                    if (scope.useTz) {
                        hour = TimeZoneFactory.currentDateToTimeZone(time, "HH");
                        minute = TimeZoneFactory.currentDateToTimeZone(time, "mm");
                    } else {
                        hour = time.getHours();
                        minute = time.getMinutes();
                    }

                    scope.inputTime.setHours(hour);
                    scope.inputTime.setMinutes(minute);
                    element.removeClass('has-error');
                } else {
                    element.addClass('has-error');
                }
            });

            scope.$watch('internalDate', function (newDate) {
                if (util.isDefined(newDate)) {
                    var newDateObject = new Date(newDate);

                    var year, month, day;

                    if (scope.useTz) {
                        year = TimeZoneFactory.formatWithTimeZone(newDateObject, "YYYY");
                        month = TimeZoneFactory.formatWithTimeZone(newDateObject, "MM")  -1;
                        day = TimeZoneFactory.formatWithTimeZone(newDateObject, "DD");
                    } else {
                        year = newDateObject.getFullYear();
                        month = newDateObject.getMonth();
                        day = newDateObject.getDate();
                    }

                    scope.inputTime.setFullYear(year);
                    scope.inputTime.setMonth(month);
                    scope.inputTime.setDate(day);

                    element.removeClass('has-error');
                } else {
                    element.addClass('has-error');
                }
            });

            scope.$watch('inputTime', function (newInputTime) {
                if (!angular.isDate(newInputTime)) {
                    scope.inputTime = new Date(newInputTime);
                }
                scope.internalTime = scope.inputTime;
                scope.internalDate = scope.inputTime;
            });

            var picker = {
                open: function () {
                    timepickerState.closeAll();
                    scope.isOpen = true;
                },
                close: function () {
                    scope.isOpen = false;
                }

            };
            timepickerState.addPicker(picker);

            scope.open = picker.open;
            scope.close = picker.close;

            scope.$watch("disabled", function (value) {
                scope.disabledInt = angular.isUndefined(scope.disabled) ? false : scope.disabled;
            });
            scope.openDatePicker = function () {
                scope.datepickerOpen = !scope.datepickerOpen;
            };
            scope.openTimePicker = function (event) {
                event.preventDefault();
                event.stopPropagation();
                if (scope.isOpen) {
                    scope.close();
                } else {
                    scope.open();
                }
            };
            scope.preventEvent = function (event) {
                event.preventDefault();
                event.stopPropagation();
            };

            $document.bind('click', function (event) {
                scope.$apply(function () {
                    scope.isOpen = false;
                });
            });

            scope.onSelectedDateChange = function(newDate) {
                scope.inputTime = newDate;
            };

        }
    };
}];